var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.222,
    height: 11,
    viewBox: "0 0 13.222 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-camera",
    "data-name": "Icon feather-camera",
    transform: "translate(-1 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6630",
    "data-name": "Trazado 6630",
    d: "M13.722,13.389A1.111,1.111,0,0,1,12.611,14.5h-10A1.111,1.111,0,0,1,1.5,13.389V7.278A1.111,1.111,0,0,1,2.611,6.167H4.833L5.944,4.5H9.278l1.111,1.667h2.222a1.111,1.111,0,0,1,1.111,1.111Z",
    fill: "none",
    stroke: "#3e3f42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6631",
    "data-name": "Trazado 6631",
    d: "M16.444,15.722A2.222,2.222,0,1,1,14.222,13.5a2.222,2.222,0,0,1,2.222,2.222Z",
    transform: "translate(-6.611 -5.667)",
    fill: "none",
    stroke: "#3e3f42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadCamera);
export default __webpack_public_path__ + "static/media/icon-upload-camera.1573313c69536ee492ce82a9453a29ed.svg";
export { ForwardRef as ReactComponent };